// ════════════════════════════════════════════════════════════════════════
// authApiClient.ts — Cliente HTTP de autenticación (JWT) (capa de
// Infraestructura)
// ════════════════════════════════════════════════════════════════════════
// Mismo patrón que leadsApiClient.ts. Habla contra el mismo backend .NET
// (ReinventX.Api) que Leads, por eso reusa la misma variable de entorno
// VITE_LEADS_API_URL. Se relocaliza tal cual desde services/authService.ts
// — el modelado del dominio de Auth queda para una fase posterior.
// ════════════════════════════════════════════════════════════════════════

import type { LoginCredentials } from '@/shared/types/auth.types';

const LEADS_API_URL: string = import.meta.env.VITE_LEADS_API_URL ?? 'http://localhost:5199';

export interface LoginResult {
  token: string;
  username: string;
  role: string;
}

// Coincide con LoginResponse (ReinventX.Application.Users.Commands.Login) —
// System.Text.Json serializa en camelCase por defecto en ASP.NET Core.
type LoginApiResponse = LoginResult;

export const login = async (credentials: LoginCredentials): Promise<LoginResult> => {
  const response = await fetch(`${LEADS_API_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(credentials),
    signal: AbortSignal.timeout(10_000),
  });

  if (!response.ok) {
    throw new Error(
      response.status === 401
        ? 'Usuario o contraseña incorrectos.'
        : `Error del servidor (${response.status}).`,
    );
  }

  return (await response.json()) as LoginApiResponse;
};
